<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card card-competencias">
          <div class="card-header">
            <h4 class="card-title">Power University</h4>
            <p class="category">by Microsoft</p>
            <img src="static/img/logo_power_university.png" class="logo-power-university" alt="Power University by Microsoft">
          </div>
          <div class="card-content">
            <el-collapse>
              <el-collapse-item title="Sugestão de trilhas por área" :key="keyVfor()">
                <div class="embed-responsive embed-responsive-16by9" allowfullscreen>
                  <object data="static/pdf/Power_University_Trilhas.pdf" type="application/pdf"></object>
                </div>               
              </el-collapse-item>
              <el-collapse-item title="Painel de acompanhamento" :key="keyVfor()">
                <div style="padding-top: 15px;">
                  <a href="https://app.powerbi.com/links/CDnTDvk2bW?ctid=d895c5b4-1caf-40f3-b3c4-7124c8711044&pbi_source=linkShare" target="_blank" class="btn btn-info btn-fill btn-wd">
                    <i class="fa fa-bar-chart" aria-hidden="true"></i> Abrir no Powerbi
                  </a>
                </div>       
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Collapse, CollapseItem} from 'element-ui'
  import VueTabs from 'vue-nav-tabs'

  Vue.use(VueTabs)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  export default {
    methods: {
      keyVfor () {
        return Math.random().toString(5).slice(2)
      }
    }
  }
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/PowerUniversity.vue